// Local image paths to replace external URLs
export const localImages = {
    // Truck and transportation images
    americanStyleTruck: "/images/external/american-style-truck.jpg",
    truckTransport: "/images/external/truck-transport.jpg",

    // Placeholder images for blocked/unavailable external URLs
    semiTruckFact: "/images/external/american-style-truck.jpg", // Using available image as fallback
    truckTrailerSunset: "/images/external/truck-transport.jpg", // Using available image as fallback

    // Additional local images
    defaultTruck: "/images/external/american-style-truck.jpg",
    defaultTransport: "/images/external/truck-transport.jpg",

    // UI and construction images
    construction: "/images/external/construction.gif",
    locationPin: "/images/external/location-pin.png",
    deliveryTruck: "/images/external/delivery-truck.png",

    // User profile images
    blankProfilePicture: "/images/external/blank-profile-picture.png"
};

// Function to get a local image with fallback
export const getLocalImage = (imageType: keyof typeof localImages, fallback?: string): string => {
    return localImages[imageType] || fallback || localImages.defaultTruck;
};
